/* ============================================================
   OnlySkin — Tema Shopify · theme.js
   Carrito AJAX, menú móvil, acordeón, variantes, reveal on scroll
   ============================================================ */
(function () {
  'use strict';

  const money = (cents) => {
    const fmt = (window.OnlySkin && window.OnlySkin.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* ---------- Cart count refresh ---------- */
  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) { /* noop */ }
  }

  /* ---------- Add to cart (AJAX) ---------- */
  async function addToCart(variantId, quantity, btn) {
    if (!variantId) return;
    const original = btn ? btn.innerHTML : null;
    if (btn) { btn.setAttribute('disabled', ''); btn.dataset.loading = '1'; btn.textContent = 'Añadiendo…'; }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
      });
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Error al añadir al carrito');
      }
      await refreshCartCount();
      openCartDrawerOrNotice(btn);
    } catch (e) {
      alert(e.message);
    } finally {
      if (btn) {
        btn.removeAttribute('disabled'); delete btn.dataset.loading;
        if (original !== null) btn.innerHTML = original;
        if (window.lucide) window.lucide.createIcons();
      }
    }
  }

  function openCartDrawerOrNotice(btn) {
    if (btn) {
      const prev = btn.innerHTML;
      btn.innerHTML = '✓ Añadido';
      setTimeout(() => { btn.innerHTML = prev; if (window.lucide) window.lucide.createIcons(); }, 1600);
    }
  }

  /* ---------- Delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    // quick add / add to cart buttons
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      const form = addBtn.closest('form');
      let variantId = addBtn.getAttribute('data-variant-id');
      let qty = 1;
      if (form) {
        const vEl = form.querySelector('[name="id"]');
        if (vEl) variantId = vEl.value;
        const qEl = form.querySelector('[name="quantity"]');
        if (qEl) qty = parseInt(qEl.value, 10) || 1;
      }
      addToCart(variantId, qty, addBtn);
      return;
    }

    // accordion
    const acc = e.target.closest('.accordion-trigger');
    if (acc) {
      const body = acc.nextElementSibling;
      const isOpen = body.classList.contains('open');
      acc.parentElement.parentElement.querySelectorAll('.accordion-body').forEach((b) => b.classList.remove('open'));
      acc.parentElement.parentElement.querySelectorAll('.accordion-trigger').forEach((b) => b.classList.remove('open'));
      if (!isOpen) { body.classList.add('open'); acc.classList.add('open'); }
      return;
    }

    // mobile menu toggle
    if (e.target.closest('[data-menu-toggle]')) {
      const menu = document.getElementById('mobile-menu');
      if (menu) menu.classList.toggle('open');
      return;
    }

    // collection filters toggle (mobile)
    if (e.target.closest('[data-filter-toggle]')) {
      const sb = document.getElementById('collection-sidebar');
      if (sb) sb.classList.toggle('open');
      return;
    }

    // qty steppers (PDP)
    const stepper = e.target.closest('[data-qty-step]');
    if (stepper) {
      const input = document.getElementById('qty-input');
      if (input) {
        const delta = parseInt(stepper.getAttribute('data-qty-step'), 10);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      }
      return;
    }

    // PDP thumbnails
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      const main = document.getElementById('pdp-main-img');
      if (main) {
        main.src = thumb.getAttribute('data-thumb');
        main.srcset = '';
      }
      document.querySelectorAll('[data-thumb]').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
      return;
    }

    // PDP prev/next arrows
    const navBtn = e.target.closest('[data-pdp-prev],[data-pdp-next]');
    if (navBtn) {
      const thumbs = Array.from(document.querySelectorAll('[data-thumb]'));
      if (!thumbs.length) return;
      let idx = thumbs.findIndex((t) => t.classList.contains('active'));
      if (idx < 0) idx = 0;
      const dir = navBtn.hasAttribute('data-pdp-next') ? 1 : -1;
      idx = (idx + dir + thumbs.length) % thumbs.length;
      const target = thumbs[idx];
      const main = document.getElementById('pdp-main-img');
      if (main) { main.src = target.getAttribute('data-thumb'); main.srcset = ''; }
      thumbs.forEach((t) => t.classList.remove('active'));
      target.classList.add('active');
      return;
    }
  });

  /* ---------- Variant selection (PDP) ---------- */
  function initVariantSelector() {
    const root = document.querySelector('[data-product-json]');
    if (!root) return;
    let product;
    try { product = JSON.parse(root.textContent); } catch (e) { return; }

    const selects = document.querySelectorAll('[data-variant-option]');
    const idInput = document.querySelector('[data-variant-id-input]');
    const priceEl = document.querySelector('[data-variant-price]');
    const compareEl = document.querySelector('[data-variant-compare]');
    const addBtn = document.querySelector('[data-add-to-cart]');
    if (!selects.length || !idInput) return;

    function currentVariant() {
      const chosen = Array.from(selects).map((s) => s.value);
      return product.variants.find((v) => v.options.every((opt, i) => opt === chosen[i]));
    }

    function update() {
      const v = currentVariant();
      if (!v) {
        if (addBtn) { addBtn.setAttribute('disabled', ''); addBtn.querySelector('span') && (addBtn.querySelector('span').textContent = 'No disponible'); }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareEl.textContent = money(v.compare_at_price); compareEl.style.display = '';
          priceEl && priceEl.classList.add('on-sale');
        } else { compareEl.style.display = 'none'; priceEl && priceEl.classList.remove('on-sale'); }
      }
      if (addBtn) {
        const label = addBtn.querySelector('span');
        if (v.available) { addBtn.removeAttribute('disabled'); if (label) label.textContent = 'Añadir al carrito'; }
        else { addBtn.setAttribute('disabled', ''); if (label) label.textContent = 'Agotado'; }
      }
    }
    selects.forEach((s) => s.addEventListener('change', update));
    update();
  }

  /* ---------- Cart page line updates ---------- */
  async function changeLine(line, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
    return res.json();
  }
  document.addEventListener('click', async function (e) {
    const rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      const line = parseInt(rm.getAttribute('data-line'), 10);
      await changeLine(line, 0);
      window.location.reload();
    }
  });
  document.addEventListener('change', async function (e) {
    const qty = e.target.closest('[data-cart-qty]');
    if (qty) {
      const line = parseInt(qty.getAttribute('data-line'), 10);
      await changeLine(line, parseInt(qty.value, 10) || 0);
      window.location.reload();
    }
  });

  /* ---------- Hero slideshow ---------- */
  function initHeroSlideshow() {
    const box = document.querySelector('[data-hero-slideshow]');
    if (!box) return;
    const slides = Array.from(box.querySelectorAll('.hero-slide'));
    const dots = Array.from(box.querySelectorAll('[data-hero-dot]'));
    if (slides.length < 2) { if (dots.length) dots.forEach(d => d.remove()); return; }
    let i = 0;
    const interval = (parseInt(box.getAttribute('data-interval'), 10) || 5) * 1000;
    let timer;
    function show(n) {
      slides[i].classList.remove('active');
      if (dots[i]) dots[i].classList.remove('active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('active');
      if (dots[i]) dots[i].classList.add('active');
    }
    function start() { timer = setInterval(() => show(i + 1), interval); }
    function reset() { clearInterval(timer); start(); }
    dots.forEach((dot) => dot.addEventListener('click', () => { show(parseInt(dot.getAttribute('data-hero-dot'), 10)); reset(); }));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    const els = document.querySelectorAll('.reveal, .reveal-scale');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach((el) => el.classList.add('visible')); return;
    }
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add('visible'); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    els.forEach((el) => obs.observe(el));
  }

  /* ---------- Init ---------- */
  function init() {
    refreshCartCount();
    initVariantSelector();
    initHeroSlideshow();
    initReveal();
    if (window.lucide) window.lucide.createIcons();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
